import React, { useState } from 'react'
import { Image } from 'antd'
import { EyeOutlined } from '@ant-design/icons'

export const TripPictureV2 = ({
  trip,
  style = {},
  height = '400px',
  preview = true,
}) => {
  let pictureUrl = null
  const [visible, setVisible] = useState(false)
  if (
    trip &&
    trip.hasOwnProperty('thumbnailUrls') &&
    trip.thumbnailUrls &&
    trip.thumbnailUrls.length > 0
  )
    pictureUrl = trip.thumbnailUrls[0]
  else if (typeof trip.pictureUrls == 'string') pictureUrl = trip.pictureUrls
  else
    pictureUrl =
      trip && trip.pictureUrls && trip.pictureUrls.length > 0
        ? trip.pictureUrls[0]
        : null

  if (pictureUrl) style['backgroundImage'] = `url("${pictureUrl}")`
  return (
    <div
      className="image-viewer no-image"
      style={{
        height: height,
        ...style,
      }}
    >
      {preview && pictureUrl && (
        <>
          <div className="image-preview" onClick={() => setVisible(true)}>
            <EyeOutlined /> Preview
          </div>
          <Image
            style={{
              display: 'none',
            }}
            src={pictureUrl}
            preview={{
              visible,
              src: pictureUrl,
              onVisibleChange: (value) => {
                setVisible(value)
              },
            }}
          />
        </>
      )}
    </div>
  )
}

export const Logo = ({ url, style = {}, height = '100px' }) => {
  if (url) style['backgroundImage'] = `url("${url}")`
  return (
    <div
      className="image-viewer no-image"
      style={{
        height: height,
        width: height,
        minHeight: height,
        ...style,
      }}
    ></div>
  )
}
